const ROOT = 'LoginMfa/loginMfa/userOdt';

export const FETCH_LOGIN_MFA_REQUEST                        = `${ROOT}/FETCH_LOGIN_MFA_REQUEST`;
export const FETCH_LOGIN_MFA_RESEND_REQUEST                 = `${ROOT}/FETCH_LOGIN_MFA_RESEND_REQUEST`;
export const FETCH_LOGIN_MFA_SUCCESS                        = `${ROOT}/FETCH_LOGIN_MFA_SUCCESS`;
export const FETCH_LOGIN_MFA_RESEND_OTP                     = `${ROOT}/FETCH_LOGIN_MFA_RESEND_OTP`;
export const FETCH_LOGIN_MFA_SESSION_TOKEN_ERROR            = `${ROOT}/FETCH_LOGIN_MFA_SESSION_TOKEN_ERROR`;
export const FETCH_LOGIN_MFA_OTP_ERROR                      = `${ROOT}/FETCH_LOGIN_MFA_OTP_ERROR`;
export const FETCH_LOGIN_MFA_EXCEEDED_OTP_ATTEMPTS_ERROR    = `${ROOT}/FETCH_LOGIN_MFA_EXCEEDED_OTP_ATTEMPTS_ERROR`;
export const FETCH_LOGIN_MFA_FAILURE                        = `${ROOT}/FETCH_LOGIN_MFA_FAILURE`;
